module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><path d=\"M31.443 28.846c.742.743.742 1.856.002 2.599-.373.37-.835.556-1.3.556-.464 0-.928-.186-1.299-.556L19.2 21.798a11.965 11.965 0 0 1-7.143 2.318A12.033 12.033 0 0 1 0 12.059C0 5.38 5.38 0 12.059 0a12.033 12.033 0 0 1 12.057 12.057c0 2.69-.835 5.195-2.318 7.143l9.645 9.646zm-19.384-8.44a8.314 8.314 0 0 0 8.348-8.347 8.312 8.312 0 0 0-8.348-8.348A8.312 8.312 0 0 0 3.71 12.06a8.312 8.312 0 0 0 8.348 8.348z\"/></svg>\n"


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/Icon/magnifier.svg
// module id = 840
// module chunks = 0